import React,{ useState, useEffect, useRef }  from 'react';
import {Container,Button,Header} from 'semantic-ui-react'
import { useHistory } from "react-router-dom";
import MyTabulator,{autoNumFormatter} from '@wollo-lib/wollo-tabulator'

import {showDatum} from '@wollo-lib/wollo-react'
import ModalEditUser from './ModalEditUser'




const UserList=({usersDB,db,dbRevision})=>
{
    
    const history=useHistory()


    const [userSelected, setUserSelected]=useState(-1)
    const [users,setUsers]= useState([])
    const [revision,setRevision]=useState(0)
    const [modalOpen, setModalOpen]= useState(false)


    const hasError=useRef(false)


    const tabulatorEl = useRef(null);
    const tab=useRef(null)
    
    const dateFormatter=(cell, formatterParams, onRendered)=>
    {
      return showDatum(cell.getValue())
    }

    useEffect(()=>{
      const getUsers=async ()=>
      {
        const myUsers=await usersDB.orderBy('Nachname').toArray()
        setUsers(myUsers)
      }
      getUsers()
    },[revision,dbRevision])
    function cellClick (cell) 
    {
        let row=cell.getRow()
        if(cell.getField()==='UID')
        {
            setUserSelected(row.getPosition())
            setModalOpen(true)
        }
    }

   

   

    

    const columns=[
   
        {formatter:autoNumFormatter, width:50, frozen:true}, //incrementing row number
        {formatter:(cell, formatterParams)=>('<i class="icon edit"></i>'), field:'UID', width:50, hozAlign:"center"}, // edit 
        { title: 'Vorname', field: 'Vorname', width: 120,  headerFilter:"input"},
        { title: 'Nachname', field: 'Nachname', width: 120,  headerFilter:"input"},
        { title: 'Plz', field: 'PLZ', width: 100,  headerFilter:"input"},
        { title: 'Ort', field:'Ort', width: 200, headerFilter:"input"},
        { title: 'Land', field: 'Land', width: 50,  headerFilter:"input"},
        { title: 'email', field: 'email',   width: 200},  
        { title: 'Festnetz', field: 'Festnetz',   width: 200 },    
        { title: 'mobil', field: 'mobil',   width: 200 },
    ]



    return(
    <>
        <Container>
            <Header as ="h1">Kundenliste</Header>
            <Button color='green' icon='plus' content='neuer Kunde' onClick={(e)=>{setUserSelected(-1); setModalOpen(true)}}/>
            <MyTabulator
                index='UID'
                columns={columns}
                headerFilterPlaceholder="Spalte filtern"
                data={users}
                onClick={cellClick}
                pagination="local"
                height="800px"
             />
        </Container>
        <ModalEditUser
          open={modalOpen}
          setOpen={setModalOpen}
          usersDB={usersDB}
          setRevision={setRevision}
          UID={users[userSelected] ? users[userSelected].UID : null}
          db={db}
        />
    </>
    )
}
export default UserList
